
import { DateTime, DateTimeFormatOptions } from 'luxon';
import { GetServerSideProps } from 'next';
import Head from 'next/head';

import { MenuId } from '../../components/Header';
import Layout from '../../components/Layout';
import { Workshop, ImageData, WorkshopStatus } from '../../lib/definitions'
import styles from './[event].module.scss'
import {Button, Space, Text} from '@mantine/core'

import Link from 'next/link';
import { getGalleryImages, redirectUrl } from '../../lib/data';
import { Carousel } from '@mantine/carousel';
import CornerBanner from '../../components/CornerBanner';

import { useRouter } from 'next/router';
import { MyCarousel } from '../../components/MyCarousel';
import { AspectBox } from '../../components/AspectBox';
import { UKDate } from '../../components/Localization';

type Data = {
  workshop : Workshop,
  images: ImageData []
    }

export default function Event({data} : {data: Data})
{
    const router = useRouter();

    const w = data.workshop;
    const dtFrom = DateTime.fromISO(w.dateStart);
    const dtTo = DateTime.fromISO(w.dateEnd);

    //const dtFormat="cccc d LLLL, yyyy";

    const soldOut = w.ticketsSold>=w.totalTickets || w.status==WorkshopStatus.full;

    let html = {__html: w.description};
    let description = <div dangerouslySetInnerHTML={html}></div>

    let slides: JSX.Element []  = [];

    let structuredData =
    {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": w.title,
      "startDate": DateTime.fromISO(w.dateStart).startOf('day').plus({hours:10}),
      "endDate": DateTime.fromISO(w.dateEnd).startOf('day').plus({hours:17}),
      "eventStatus": "https://schema.org/EventScheduled",
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "location": {
        "@type": "Place",
        "name": "Raw Umber Studios",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "16 Nelson Street",
          "addressLocality": "Stroud",
          "postalCode": "GL5 2HN",
          "addressRegion": "Gloucestershire",
          "addressCountry": "UK"
        }
      },
      "image": [
        "https://rawumberstudios.com/n/api/thumbnails/" + w.imageId + ".jpg?w=840"
       ],
      "description": w.excerpt,
    "offers": {
        "@type": "Offer",
        "url": "https://rawumberstudios.com/events" + w.slug,
        "price": w.price,
        "priceCurrency": "GBP",
        "availability": "https://schema.org/InStock"
      },
      "performer": {
        "@type": "Person",
        "name": w.tutor
      },
      "organizer": {
        "@type": "Organization",
        "name": "Raw Umber Studios",
        "url": "https://rawumberstudios.com"
      }
    }

    data.images.forEach(x=>
      {
        if (x.filename)
        {
          slides.push(<MyCarousel.Slide key={x.id}>
          
            <div style={{height:'100%', position:'relative'}}>
            <svg xmlns="http://www.w3.org/2000/svg"
            height={x.height}
            width={x.width}
            style={{width:"auto", height:"100%"}}>
              
            </svg>

            <img style={{position:'absolute', left:'0', top:'0', width:'100%', height:'100%'}} src={"/n/api/thumbnails/" + x.id + "?t=" + x.updatedAt + "&h=400"}></img>



            
            </div>
            </MyCarousel.Slide>);
        }
      })

    //consoleLog(slides.length);

    let ticketsLeft = w.totalTickets - w.ticketsSold;

    let banner = <></>
    let button = <></>
    let bannerText="";

    if (dtFrom>=DateTime.local().toUTC())
    {
      if (soldOut)
      {
          banner = <CornerBanner text="Sold out!" color='white' backgroundColor='#e00'/>
      }
      else if (ticketsLeft<4)
      {
          bannerText = ticketsLeft + " space" + (ticketsLeft==1?'':'s') + " left";
          banner = <CornerBanner text={bannerText} color='white' backgroundColor='#f60'/>
      }  

      if (w.status==WorkshopStatus.cancelled)
      {
        button = <Text>Unfortunately we&rsquo;ve had to cancel this workshop. But <Link href="/new-events">check out our future worshops too!</Link></Text>
      }
      else
      {
        if (soldOut)
        {
          button = <Button color="lime" radius="md" size="xl" fullWidth onClick={waitList}>Join the wait list</Button>
        }
        else
        {
          button = <Button color="lime" radius="md" size="xl" fullWidth onClick={registerNow}>Register Now!</Button>
        }
      }
    }
    else
    {
      button = <Text>This workshop has already happened. But <Link href="/new-events">check out our future worshops too!</Link></Text>
    }


    function registerNow()
    {
        router.push("/events/" + w.slug + "/register");
    }

    function waitList()
    {
        router.push("/events/" + w.slug + "/register");
    }

  return(
    
    <>
  <Layout menuId={MenuId.workshops} hidePopUp>
  <Head>
      <title>{w.title}</title>
      <meta name="description" content={w.excerpt}/>

      <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
  />

<style>
  {
`blockquote
{
    border-style: solid;
    border-width: 0px 0px 0px 3px;
    margin-left: 16px;
    padding-left: 6px;
    border-color: red;
}`
}
</style>

  </Head>

  <div className = {styles.mainContent}>
  <h1 className={styles.h1}>{w.title}</h1>

<div className={styles.info}>
    {banner}
  <Text><b>Date:</b> <UKDate date={dtFrom}/> - <UKDate date={dtTo}/></Text>
  <Text><b>Time:</b> 10am - 5pm</Text>
    <Text><b>Tutor:</b> {w.tutor}</Text>
    <Text><b>Cost:</b> £{w.price}</Text>
    <Text><b>Location:</b> <Link href='/about-our-studio/'>Raw Umber Studios, 16 Nelson Street, Stroud GL5 2HN</Link></Text>
    </div>
    <Space h='lg'/>
    {slides.length!=0 && <div className={styles.carousel}><MyCarousel     
   
    >
        {slides}
    </MyCarousel></div>
  }
    {description}

    <Space h ='lg'/>
    {button}    
   
 </div>
 <Space h ='lg'/>

</Layout></>
  );


}


export const getServerSideProps : GetServerSideProps = async (context)=>
{
    let options = { 
        method: 'GET',  cache: "no-store" as RequestCache
        };

    const slug = context.params?.event;

    var u2 = await redirectUrl(context.resolvedUrl);

    if (u2)
    {
      return {
        redirect: 
        {
          destination: "/" + u2,
          permanent: false
        }
      }
    }

    let r = await (await fetch(process.env.ADMIN_ROUTE + "/workshopfromslug?slug=" + slug + "&nocache=0" , options));

    let j = await r.text();

    const result: Workshop = JSON.parse(j);

    if (!result || (result.status!=WorkshopStatus.cancelled && result.status!=WorkshopStatus.live && result.status!=WorkshopStatus.full))
    {
        return {
            notFound: true
          } 
    }

    const images = await getGalleryImages(result.galleryId);

    return {
      props: {
        data: 
        { 
            images: images,
            workshop:result,
            dateRetrieved: DateTime.now().toISO()
        }
        }
    }
}